module.exports = __webpack_public_path__ + "static/img/academic2.72cfd66b.png";